<template>
    <b-nav-item-dropdown
        class="help-menu"
        id="topo-configuracoes"
        right
        ref="navdropdown"
    >
        <template #button-content>
            <i class="fa fa-cogs"></i>
        </template>
        <li class="header">
            Configurações
        </li>
        <li>
            <ul 
                class="menu"
            >
                <li 
                    v-for="topico in topicos" 
                    :key="topico.nome" 
                    v-show="topico.habilitado"
                >
                    <a 
                        :href="topico.link"
                        @click="$refs.navdropdown.hide()"
                    >
                        <h3>
                            <div>
                                <i 
                                    :class="topico.icone"
                                ></i> 
                                {{ topico.nome }}
                            </div>
                        </h3>
                    </a>
                </li>
            </ul>
        </li>
    </b-nav-item-dropdown>
</template>
<script>
export default {
    data(){
        return {
            topicos: [
                {
                    nome: 'Dados da contabilidade', 
                    icone: 'fa fa-suitcase', 
                    link: `${this.$urlBase}/configuracoes/dados_empresa`,
                    habilitado: true,
                },
                {
                    nome: 'Domínio próprio', 
                    icone: 'fa fa-globe', 
                    link:  `${this.$urlBase}/dominios/configurar`,
                    habilitado: true,
                },
                {
                    nome: 'Usuários', 
                    icone: 'fa fa-user', 
                    link: `${this.$urlBase}/usuarios`,
                    habilitado: true
                },
            ]
        }
    }
}
</script>
